import { memo } from 'react'

import { getRouteApi } from '@tanstack/react-router'
import { useGetCTRList } from '~bank-bsa-reporting/hooks/ctr'
import { CTRListRequest } from '~bank-bsa-reporting/types'

import { CTRList } from './components'

const routeApi = getRouteApi('/_app/bsa/ctrs/print')

const PrintCTRList = memo(() => {
  const search = routeApi.useSearch()

  const filter: CTRListRequest = {
    transactionDate: search.date,
    size: Number(search.size),
    page: Number(search.page),
    ...(search.status !== 'undefined' && { status: search.status }),
    ...(search.type !== 'undefined' && { filingType: search.type })
  }

  const { data } = useGetCTRList(filter)

  return <CTRList items={data?.items || []} />
})

export default PrintCTRList
